module.exports = __webpack_public_path__ + "static/background-75a42d504436ff7c471129a763686333.png";